import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteCostosInternos extends Component {
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    dataReporte: null,
    todasCostos: [],
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proveedores/selectProveedores",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProveedores: res.data });
          this.setState({
            objetoProveedores: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre || value.razonSocial}
              </Option>
            )),
          });
        }
      });
    this.consultarReporteCostosInternos({
      periodo: [moment().subtract(1, "month"), moment()],
      proveedores: [],
    });
  }

  consultarReporteCostosInternos(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeCompras/reporteCostosInternos",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasCostos: res.data.costos,
          });
        } else if (res.data.success === 1) {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const parseFecha = (val) => {
      if (!val) return val;
      const m = moment(val, "DD/MM/YYYY", true);
      return m.isValid() ? new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : val;
    };
    const round6Decimals = (num) => {
      if (typeof num !== "number") return num;
      const factor = 10 ** 6;
      const scaled = Number((num * factor).toPrecision(15));
      return Math.round(scaled) / factor;
    };
    const columnasFecha = ["Fecha", "Fecha Factura"];
    const columnasMoneda = [
      "Precio MXN",
      "Sub. MXN",
      "IVA MXN",
      "Ret IVA",
      "Ret ISR",
      "Total MXN",
      "Precio USD",
      "Sub. USD",
      "IVA USD",
      "Total USD",
      "Total USD (TC)",
      "Total Costo",
    ];
    const datosDescargar = this.state.todasCostos.map((v) => ({
      "Fecha Mov.": parseFecha(v.fecha),
      Semana: v.semana,
      Proveedor: v.proveedor,
      "O.C.": v.op,
      "Folio Movimiento": v.entrada,
      "Folio Movimiento Tipo": v.folioTipo,
      Factura: v.factura,
      "Fecha Rec. Factura": parseFecha(v.fechaRecepcion),
      "Fecha Factura": parseFecha(v.fechaFactura),
      Mes: v.mes,
      Almacen: v.almacen,
      "Prod/Serv": v.prodServ,
      "Cant MXN": v.cantMxn,
      "Precio MXN": round6Decimals(v.precioMxn),
      "Sub. MXN": round6Decimals(v.subMxn),
      "IVA MXN": round6Decimals(v.ivaMxn),
      "Ret IVA": round6Decimals(v.retIva),
      "Ret ISR": round6Decimals(v.retIsr),
      "Total MXN": round6Decimals(v.totalMxn),
      "Cant USD": v.cantUsd,
      "Precio USD": round6Decimals(v.precioUsd),
      "Sub. USD": round6Decimals(v.subUsd),
      "IVA USD": round6Decimals(v.ivaUsd),
      "Total USD": round6Decimals(v.totalUsd),
      Ministerio: v.ministerio,
      Descripcion: v.descripcion,
      "T.C.": v.tipoCambio,
      "Total USD (TC)": round6Decimals(v.totalUsdConvertido),
      "Total Costo": round6Decimals(v.totalCosto),
      "Responsable": v.responsable,
    }));
    const worksheet = XLSX.utils.json_to_sheet(datosDescargar, { cellDates: true });
    if (worksheet["!ref"]) {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const indicesFecha = [];
      const indicesMoneda = [];
      for (let C = range.s.c; C <= range.e.c; C++) {
        const header = worksheet[XLSX.utils.encode_cell({ r: range.s.r, c: C })];
        if (header && columnasFecha.includes(header.v)) {
          indicesFecha.push(C);
        }
        if (header && columnasMoneda.includes(header.v)) {
          indicesMoneda.push(C);
        }
      }
      for (let R = range.s.r + 1; R <= range.e.r; R++) {
        for (const C of indicesFecha) {
          const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && cell.v instanceof Date) {
            cell.t = "d";
            cell.z = "dd/mm/yyyy";
          }
        }
        for (const C of indicesMoneda) {
          const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && typeof cell.v === "number") {
            cell.z = "0.000000";
          }
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Costos Internos");
    XLSX.writeFile(
      workbook,
      `Reporte_Costos_Internos_${moment().locale("es").format("L")}.xlsx`
    );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const strSorter = (field) => (a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    };
    const numSorter = (field) => (a, b) => a[field] - b[field];

    const columns = [
      {
        title: "Fecha Mov.",
        dataIndex: "fecha",
        key: "fecha",
        sorter: (a, b) =>
          moment(a.fecha, "DD/MM/YYYY") <
          moment(b.fecha, "DD/MM/YYYY")
            ? -1
            : 1,
        buscar: "fecha",
        ellipsis: true,
        width: 95,
      },
      {
        title: "Sem",
        dataIndex: "semana",
        key: "semana",
        sorter: numSorter("semana"),
        buscar: "semana",
        ellipsis: true,
        width: 60,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "proveedor",
        sorter: strSorter("proveedor"),
        buscar: "proveedor",
        ellipsis: true,
        width: 140,
      },
      {
        title: "O.C.",
        dataIndex: "op",
        key: "op",
        sorter: strSorter("op"),
        buscar: "op",
        ellipsis: true,
        width: 80,
      },
      {
        title: "Entrada",
        dataIndex: "folioTipo",
        key: "folioTipo",
        sorter: strSorter("folioTipo"),
        buscar: "folioTipo",
        ellipsis: true,
        width: 80,
      },
      {
        title: "Factura",
        dataIndex: "factura",
        key: "factura",
        sorter: strSorter("factura"),
        buscar: "factura",
        ellipsis: true,
        width: 90,
      },
      {
        title: "Fecha Rec. Factura",
        dataIndex: "fechaRecepcion",
        key: "fechaRecepcion",
        sorter: (a, b) =>
          moment(a.fechaRecepcion, "DD/MM/YYYY") <
          moment(b.fechaRecepcion, "DD/MM/YYYY")
            ? -1
            : 1,
        buscar: "fechaRecepcion",
        ellipsis: true,
        width: 130,
      },
      {
        title: "Fecha Factura",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        sorter: (a, b) =>
          moment(a.fechaFactura, "DD/MM/YYYY") <
          moment(b.fechaFactura, "DD/MM/YYYY")
            ? -1
            : 1,
        buscar: "fechaFactura",
        ellipsis: true,
        width: 110,
      },
      {
        title: "Mes",
        dataIndex: "mes",
        key: "mes",
        sorter: strSorter("mes"),
        buscar: "mes",
        ellipsis: true,
        width: 80,
      },
      {
        title: "Proyecto",
        dataIndex: "almacen",
        key: "almacen",
        sorter: strSorter("almacen"),
        buscar: "almacen",
        ellipsis: true,
        width: 120,
      },
      {
        title: "Prod/Serv",
        dataIndex: "prodServ",
        key: "prodServ",
        sorter: strSorter("prodServ"),
        buscar: "prodServ",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Cant MXN",
        dataIndex: "cantMxn",
        key: "cantMxn",
        sorter: numSorter("cantMxn"),
        render: (value) => !value ? "-" : value,
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Precio MXN",
        dataIndex: "precioMxn",
        key: "precioMxn",
        sorter: numSorter("precioMxn"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Sub. MXN",
        dataIndex: "subMxn",
        key: "subMxn",
        sorter: numSorter("subMxn"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "IVA MXN",
        dataIndex: "ivaMxn",
        key: "ivaMxn",
        sorter: numSorter("ivaMxn"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 95,
      },
      {
        title: "Ret IVA",
        dataIndex: "retIva",
        key: "retIva",
        sorter: numSorter("retIva"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Ret ISR",
        dataIndex: "retIsr",
        key: "retIsr",
        sorter: numSorter("retIsr"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Total MXN",
        dataIndex: "totalMxn",
        key: "totalMxn",
        sorter: numSorter("totalMxn"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Cant USD",
        dataIndex: "cantUsd",
        key: "cantUsd",
        sorter: numSorter("cantUsd"),
        render: (value) => !value ? "-" : value,
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Precio USD",
        dataIndex: "precioUsd",
        key: "precioUsd",
        sorter: numSorter("precioUsd"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Sub. USD",
        dataIndex: "subUsd",
        key: "subUsd",
        sorter: numSorter("subUsd"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 95,
      },
      {
        title: "IVA USD",
        dataIndex: "ivaUsd",
        key: "ivaUsd",
        sorter: numSorter("ivaUsd"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Total USD",
        dataIndex: "totalUsd",
        key: "totalUsd",
        sorter: numSorter("totalUsd"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Ministerio",
        dataIndex: "ministerio",
        key: "ministerio",
        sorter: strSorter("ministerio"),
        buscar: "ministerio",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Descripcion",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: strSorter("descripcion"),
        buscar: "descripcion",
        ellipsis: true,
        width: 200,
      },
      {
        title: "T.C",
        dataIndex: "tipoCambio",
        key: "tipoCambio",
        sorter: numSorter("tipoCambio"),
        render: (value) => !value ? "-" : value,
        ellipsis: true,
        align: "right",
        width: 80,
      },
      {
        title: "Total USD (TC)",
        dataIndex: "totalUsdConvertido",
        key: "totalUsdConvertido",
        sorter: numSorter("totalUsdConvertido"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 115,
      },
      {
        title: "Total Costo",
        dataIndex: "totalCosto",
        key: "totalCosto",
        sorter: numSorter("totalCosto"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 105,
      },
    ];

    return (
      <>
        <Form
          name="reporteCostosInternos"
          onFinish={this.consultarReporteCostosInternos.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Costos Internos"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem
                   name="periodo" 
                   required 
                   noStyle
                   tooltip="El periodo filtra por fecha de recepción de factura"
                  >
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Proveedores">
                  <Row>
                    <Col span={16}>
                      <FormItem name="proveedores" noStyle margin>
                        <SelectItem
                          width="90%"
                          mode="multiple"
                          placeholder="Todos los proveedores"
                        >
                          {this.state.objetoProveedores}
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            <TableItem
              rowKey={(record, index) =>
                record._id ? record._id.toString() : index
              }
              columns={columns}
              dataSource={this.state.todasCostos}
              size="small"
              pagination={false}
              scroll={{ x: 2800 }}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ReporteCostosInternos);
